"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeOfImagePropertyOption = exports.isTypeOfImageProperty = exports.typeOfImagePropertyDefinition = void 0;
const typeOfImagePropertyOptions = [
    'animated',
    'image',
    'infographic',
    'logo',
];
exports.typeOfImagePropertyDefinition = {
    name: 'type-of-image',
    type: 'select',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'options',
            argument: typeOfImagePropertyOptions,
        },
    ],
    multiple: false,
    default: 'image',
    view: {
        label: 'Content type',
        style: '',
    },
};
const isTypeOfImageProperty = (prop) => {
    return prop.name === exports.typeOfImagePropertyDefinition.name;
};
exports.isTypeOfImageProperty = isTypeOfImageProperty;
const isTypeOfImagePropertyOption = (option) => {
    return typeOfImagePropertyOptions.includes(option);
};
exports.isTypeOfImagePropertyOption = isTypeOfImagePropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS1vZi1pbWFnZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3R5cGUtb2YtaW1hZ2UucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsTUFBTSwwQkFBMEIsR0FBRztJQUNqQyxVQUFVO0lBQ1YsT0FBTztJQUNQLGFBQWE7SUFDYixNQUFNO0NBQ0UsQ0FBQTtBQUVHLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLGVBQWU7SUFDckIsSUFBSSxFQUFFLFFBQVE7SUFDZCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLDBCQUEwQjtTQUNyQztLQUNGO0lBQ0QsUUFBUSxFQUFFLEtBQUs7SUFDZixPQUFPLEVBQUUsT0FBTztJQUNoQixJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsY0FBYztRQUNyQixLQUFLLEVBQUUsRUFBRTtLQUNWO0NBQzhCLENBQUE7QUFJMUIsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLElBQWtCLEVBQStCLEVBQUU7SUFDdkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFDQUE2QixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakM7QUFJTSxNQUFNLDJCQUEyQixHQUFHLENBQUMsTUFBYyxFQUF1QyxFQUFFO0lBQ2pHLE9BQVEsMEJBQWdELENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFBO0FBQzNFLENBQUMsQ0FBQTtBQUZZLFFBQUEsMkJBQTJCLCtCQUV2QyJ9